import React from 'react';
import { Body, Label, Modal } from '@icarros/ids-react';
import { ModalBody } from './style';

interface ExpiredModalProps {
  modalOpen: boolean;
  setModalOpen(value: boolean): void;
}

export function Expired({ modalOpen, setModalOpen }: ExpiredModalProps): JSX.Element {
  return (
    <Modal
      stateOpen={[modalOpen, setModalOpen]}
      body={
        <ModalBody>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            Todo o anúncio que atinge o prazo de vencimento de plano passa para o status expirado.
            Saiba mais sobre os prazos e condições dos planos disponíveis:
          </Body>
          <Label contrast="default" variant="neutral" size="medium" weight="bold">
            plano 60 dias
          </Label>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            O anúncio ficará publicado por 60 dias corridos. Após o prazo, caso queira reativar seu
            anúncio será necessário escolher novamente um plano.
          </Body>
          <Label contrast="default" variant="neutral" size="medium" weight="bold">
            plano Até vender
          </Label>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            O plano tem validade ilimitada, mas para evitar que carros já vendidos continuem
            publicados no site, o anúncio é desativado a cada 90 dias. Não se preocupe, a renovação
            é sem custos e você será notificado quando o prazo chegar.
          </Body>
        </ModalBody>
      }
      title="o que são os anúncios expirados?"
      mainButtonText="entendi"
      mainButtonMethod={() => setModalOpen(false)}
    />
  );
}
